import { render, staticRenderFns } from "./SubCompetenceItem.vue?vue&type=template&id=4a17eef4&scoped=true"
import script from "./SubCompetenceItem.vue?vue&type=script&lang=js"
export * from "./SubCompetenceItem.vue?vue&type=script&lang=js"
import style0 from "./SubCompetenceItem.vue?vue&type=style&index=0&id=4a17eef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a17eef4",
  null
  
)

export default component.exports